import React from 'react'
import styled from 'styled-components'
import cn, { Argument as ClassName } from 'classnames'

import { Button } from '../common/components/Button'
import useText from '../common/hooks/useText'

import BootstrapModalLayout from './BootstrapModalLayout'

const SMessage = styled.p`
    font-family: ${({ theme }) => theme.font.name};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
`

const STitle = styled(SMessage)`
    font-weight: 500;
    font-family: ${({ theme }) => theme.font.extendedName};
    font-size: 24px;
    line-height: 32px;
    text-transform: capitalize;
`

const SFormActions = styled.div`
    display: flex;
    justify-content: center;
    gap: ${({ theme }) => theme.sizing.margin.l};

    button {
        min-width: 150px;
    }
`

const SContainer = styled.div`
    &.unlock-installation-settings-modal ${STitle} {
        font-size: 15px;
        font-weight: 500;
        line-height: 22px;
    }
`

export const AlertModalContent = ({
    title,
    message,
    showCancel,
    className,
    dismiss,
    close,
    okButtonText,
}: Props): React.ReactElement => {
    const text = useText()
    return (
        <SContainer className={cn(className, 'AlertModal')}>
            {title && <STitle data-testid="title">{title}</STitle>}
            <SMessage data-testid="message">{message}</SMessage>
            <SFormActions className="form-actions">
                {showCancel && (
                    <Button
                        type="button"
                        onClick={() => {
                            dismiss && dismiss()
                        }}
                        data-testid="btn-cancel"
                        label={text('btnCancel')}
                        className="secondary"
                    />
                )}
                <Button
                    type="button"
                    onClick={() => {
                        close && close(true)
                    }}
                    data-testid="btn-ok"
                    label={okButtonText || text('btnOK')}
                />
            </SFormActions>
        </SContainer>
    )
}

export default function AlertModal({
    dismiss,
    message,
    okButtonText,
    title,
    className,
    showCancel = false,
    close,
}: Props): React.ReactElement {
    return (
        <BootstrapModalLayout size={480}>
            <AlertModalContent
                dismiss={dismiss}
                message={message}
                okButtonText={okButtonText}
                title={title}
                className={className}
                showCancel={showCancel}
                close={close}
            />
        </BootstrapModalLayout>
    )
}

export type Props = {
    className?: ClassName
    dismiss?: (reason?: string) => void
    title?: string
    message: string | React.ReactElement
    okButtonText?: string
    showCancel?: boolean
    close?: (result: boolean) => void
}
